import { useEffect, useState } from "react"
import { get } from "helpers/api_helper"
import { refundReasons } from "../../withdrawalFinanceText"
import { unnamedParticipant } from "../../components/participantIdentity"

export const waitingName = person => [person?.firstName, person?.lastName].filter(Boolean).join(" ") || unnamedParticipant(person) || "Participant unavailable"
export const waitingEntryName = entry => entry.participants.map(waitingName).join(" / ")
export const waitingEntriesPath = (eventId, competitionId) => `/events/${eventId}/competitions/${competitionId}/entries#entries-waiting-list`

export function useWaitingListPreview(eventId, competitionId, version = 0, enabled = true) {
  const [request, setRequest] = useState({ loading: true }), [attempt, setAttempt] = useState(0)
  useEffect(() => {
    if (!enabled) return undefined
    let active = true
    setRequest({ loading: true })
    get(`/admin/events/${eventId}/competitions/${competitionId}/waiting-list-resolution`).then(({ data }) => {
      if (data?.eventId !== eventId || data?.competitionId !== competitionId || !/^[a-f\d]{64}$/.test(data.revision || "") || !Array.isArray(data.eligible) || !Array.isArray(data.review)) throw new Error("Invalid Waiting List preview")
      if (active) setRequest({ data })
    }).catch(() => { if (active) setRequest({ error: true }) })
    return () => { active = false }
  }, [eventId, competitionId, version, attempt, enabled])
  return { ...request, retry: () => setAttempt(value => value + 1) }
}

const reasonMessages = {
  ENTRY_IDENTITY_UNVERIFIED: "The registered participants could not be identified reliably.",
  ENTRY_NOT_CONFIRMED: "Registration has not been confirmed.",
  ENTRY_OPERATION_IN_PROGRESS: "Another action for this entry is still processing.",
  PARTICIPATION_HISTORY_UNVERIFIED: "We could not verify whether these participants were previously admitted to this competition.",
  PARTICIPATION_CHECK_UNAVAILABLE: "The participation check is temporarily unavailable. Retry verification.",
  PARTICIPATION_RECORDED: "At least one participant was previously admitted to a list or draw. An administrator declaration cannot override this record.",
  PAYMENT_STATUS_UNVERIFIED: "Payment status could not be verified.",
  REFUND_SOURCE_UNVERIFIED: "The payment for this exact entry could not be verified.",
}
// A review row whose refund quote failed carries the quote's own reason (Payments), worded
// once in the Withdrawals labels module.
export const waitingReason = reason => reasonMessages[reason] || refundReasons[reason] || "The entry or its payment needs verification before withdrawal."
export const waitingHistoryDetails = (entry, coverage) => {
  const reasons = entry.evidenceReasons || [], details = []
  if (reasons.includes("PARTICIPATION_HISTORY_INCOMPLETE")) {
    const codes = coverage?.reasons || []
    details.push(codes.includes("COMPETITION_PREDATES_TRACKING") ? "This competition was created before full participation history was recorded."
      : codes.includes("MATCH_HISTORY_IDENTITIES_UNVERIFIED") ? "Some participants in the match history could not be identified."
        : "The recorded participation history is incomplete.")
  }
  if (reasons.includes("ENTRY_HISTORY_INCOMPLETE")) details.push("This registration does not have a complete list movement history.")
  return details.join(" ")
}
